<script setup lang="ts">
defineProps<{ txt: stringI18n | undefined }>()

const on = defineModel<boolean>({ required: true, default: false })
</script>

<template>
  <button type="button" class="_row _ctrY _br99 _pt02 _pr02 _pb02 _pl02 IconSwitch" :class="{ on }" @click="on = !on" @keypress.enter="on = !on">
    <IconSwitch />
    <span v-if="txt" class="_fw-xl _ls-xs _pl14 _lh12 _fs09 _c1">{{ txt }}</span>
  </button>
</template>
